/* eslint-disable react/button-has-type */
/* eslint-disable react/jsx-key */
/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { Fragment, useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useNavigate, useLocation, Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import { styled } from '@mui/material/styles';
import { Box, Divider, AppBar, Toolbar, Typography, Link, Grid, Popper, Grow, IconButton, TextField } from '@mui/material';
import { Cancel as CancelIcon } from '@mui/icons-material';
import {Search} from 'lucide-react';

import InputAdornment from '@mui/material/InputAdornment';
// eslint-disable-next-line no-unused-vars
import { DefaultPlayer as Video } from 'react-html5video';

import { useDispatch, useSelector } from 'react-redux';
import Logo from '../../assets/logo/logo.png';
import palette from '../../theme/palette';
import ThemeProvider from '../../webTheme';
import menuItems from './MenuItems';
import DefaultNavbarDropdown from './DefaultNavbarDropdown';
import breakpoints from '../../theme/breakpoints';
import BacKToTop from '../../website/components/BackToTop';
import AccountPopover from '../dashboard/AccountPopover';
import VideoModal from '../../components/modal/VideoModal';
import LanguageSwitcher from '../../website/pages/LanguageSwitcher';
import adminServices from '../../services/adminServices';
import { useSearch } from './SearchContext';
import { setCurrencyValue, ComingFrom, ComingFromSub, FromGeneralAssessmentView, languagecodevalue } from '../../store/reducer';
import {
    getCourseProgress, getCourseDetails1, getB2BCourseList, getB2BSAT, getCourseCompletion, getLanguageCode, getB2BNeet, getOfferbaner, getLernerView, getAssessmentList, getCognitiveAssessment, getNEETAssessment, getSubscribedAssessment, getSatDetails, getRecomdedCourseList, getBundleCourses1, getCategoryDetails, getCertificateList, getAllFreeCourses, getAllcourseDetails
} from '../../Redux/Action'

import 'react-circular-progressbar/dist/styles.css';
import 'react-html5video/dist/styles.css';
import './NavbarStyle.css';
import { resolveLandingRoute } from '../../utils/roleLanding';


const RootStyle = styled(AppBar)(({ theme }) => ({
    background: 'rgb(253 253 253 / 71%);',
    backdropFilter: 'blur(6px)',
    WebkitBackdropFilter: 'blur(6px)', // Fix on Mobile
    boxShadow: '0px -30px 28px -3px #686464',
    borderBottom: '1px solid #F2F4F7',
    color: '#000',
    //   backgroundColor: alpha(theme.palette.background.default, 0.72),
    [theme.breakpoints.up('lg')]: {
        //     width: `calc(100% - ${DRAWER_WIDTH + 1}px)`,
        width: '100%',
    },
}));



// const ToolbarStyleNew = styled(Toolbar)({
//     display: 'flex',
//     justifyContent: 'space-between',
//     alignItems: 'center',
//     padding: '8px 16px',
// });

const ToolbarStyleNew = styled(Toolbar)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '8px 16px 8px 0', 
});

const MainRootStyle = styled('div')({
    display: 'flex',
    minHeight: '100%',
    overflow: 'hidden',
});

const MainStyle = styled('div')(({ theme }) => ({
    width: '100%',
    // overflow: 'auto',
    minHeight: '100%',
    background: '#FAFAFA',
}));

// ----------------------------------------------------------------------

// eslint-disable-next-line no-unused-vars, react/prop-types
export default function WebsiteLayoutUser({ onOpenSidebar }) {

    const currentPath = window.location.pathname;
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const location = useLocation();
    const { pathname } = useLocation();
    const isLogin = useSelector((state) => state.isLogin);
    const userRole = useSelector((state) => (state.userInfo ? state.userInfo.role : null));
    const userInfo = useSelector((state) => state.userInfo);
    const currencyType = useSelector((state) => (state?.userInfo && state?.userInfo?.currencyType ? state?.userInfo?.currencyType.code : null))
    const allDetails = useSelector((state) => state);
    const [anchorEl, setAnchorEl] = useState(null);
    const openMenu = Boolean(anchorEl);
    const [anchorEl2, setAnchorEl2] = useState(null);
    const openCourseMenu = Boolean(anchorEl2);
    const test = true;
    const [dropdown, setDropdown] = useState('');
    const [dropdownEl, setDropdownEl] = useState('');
    const [dropdownName, setDropdownName] = useState('');
    const [arrowRef, setArrowRef] = useState(null);

    const [nestedDropdown, setNestedDropdown] = useState('');
    const [nestedDropdownEl, setNestedDropdownEl] = useState('');
    const [nestedDropdownName, setNestedDropdownName] = useState('');

    const [mobileNavbar, setMobileNavbar] = useState(false);
    const [mobileView, setMobileView] = useState(false);
    const [openContent, setOpenContent] = React.useState(false);
    const [pageNameView, setPageNameView] = useState('');

    const openMobileNavbar = () => setMobileNavbar(!mobileNavbar);

    const handleNavigate = () => {
        // if(clickvideo === null || clickvideo === true){
        navigate("/auth/subscribe")
        dispatch(ComingFrom("Dashboard"))

        dispatch(FromGeneralAssessmentView(false))

        // }
    }
    const handleNavigatetoDashboard = () => {
        // if(clickvideo === null || clickvideo === true){
        dispatch(getCourseCompletion(allDetails?.userInfo?.id))
        navigate("/auth/subscribe")
        dispatch(FromGeneralAssessmentView(false))
        dispatch(ComingFrom("Dashboard"))
        dispatch(ComingFromSub("AllCourses"))

        // }
    }

    const { searchQuery, status, setSearchQuery, clearSearch, handleKeyPress } = useSearch();
    const [currency, setCurrency] = React.useState(currencyType || 'USD');
    useEffect(() => {

        if (status || allDetails?.comingfrom === 'SAT/ACT') {
            setSearchQuery(null);
        }
    }, [status, setSearchQuery])

    React.useMemo(() => {
        dispatch(setCurrencyValue(currency));
    }, [currency])



    useEffect(() => {
        function displayMobileNavbar() {
            if (window.innerWidth < breakpoints.values.lg) {
                setMobileView(true);
                setMobileNavbar(false);
            } else {
                setMobileView(false);
                setMobileNavbar(false);
            }
        }
        window.addEventListener('resize', displayMobileNavbar);

        displayMobileNavbar();

        return () => window.removeEventListener('resize', displayMobileNavbar);
    }, [location]);


    const CallBack = (data) => {
        setPageNameView(data)
    }

    useEffect(() => {
        if (!isLogin || (pathname !== '/sign-up' && pathname !== '/login')) return;
        // Shared resolver - see utils/roleLanding.
        const target = resolveLandingRoute(userInfo);
        if (!target) return;
        if (target === '/app/course') dispatch(languagecodevalue('en'));
        navigate(target, { replace: true });
    }, [pathname]);
    // eslint-disable-next-line no-unused-vars
    const renderNavbarItems = menuItems(isLogin, userRole).map(({ name, icon, href, route, collapse }) => (
        <DefaultNavbarDropdown
            key={name}
            name={name}
            icon={icon}
            href={href}
            route={route}
            collapse={Boolean(collapse)}
            onMouseEnter={({ currentTarget }) => {
                if (collapse) {
                    setDropdown(currentTarget);
                    setDropdownEl(currentTarget);
                    setDropdownName(name);
                } else {
                    setDropdown(null);
                }
            }}
        />
    ));

    const renderRoutes = menuItems(isLogin, userRole).map(({ name, listStyle, collapse, columns, rowsPerColumn }) => {
        let template;
        // Render the dropdown menu that should be display as columns
        if (collapse && columns && name === dropdownName) {
            const calculateColumns = collapse.reduce((resultArray, item, index) => {
                const chunkIndex = Math.floor(index / rowsPerColumn);

                if (!resultArray[chunkIndex]) {
                    resultArray[chunkIndex] = [];
                }

                resultArray[chunkIndex].push(item);

                return resultArray;
            }, []);

            template = (
                <Grid key={name} container spacing={2} py={1} px={1.5}>
                    {calculateColumns.map((cols, key) => {
                        const gridKey = `grid-${key}`;
                        const dividerKey = `divider-${key}`;

                        return (
                            <Grid key={gridKey} item xs={12 / columns} sx={{ position: 'relative' }}>
                                {cols.map((col) => (
                                    <Fragment key={col.name}>
                                        <Typography
                                            display="block"
                                            variant="button"
                                            fontWeight="bold"
                                            textTransform="capitalize"
                                            py={1}
                                            px={0.5}
                                        //   mt={index !== 0 ? 2 : 0}
                                        >
                                            {col.name}
                                        </Typography>
                                        {col.collapse.map((item) => (
                                            <Typography
                                                key={item.name}
                                                component={item.route ? Link : Link}
                                                to={item.route ? item.route : ''}
                                                href={item.href ? item.href : (e) => e.preventDefault()}
                                                target={item.href ? '_blank' : ''}
                                                rel={item.href ? 'noreferrer' : 'noreferrer'}
                                                minWidth="11.25rem"
                                                display="block"
                                                variant="button"
                                                color="text"
                                                textTransform="capitalize"
                                                fontWeight="regular"
                                                py={0.625}
                                                px={2}
                                                sx={({ palette: { grey } }) => ({
                                                    borderRadius: 'md',
                                                    cursor: 'pointer',
                                                    transition: 'all 300ms linear',

                                                    '&:hover': {
                                                        backgroundColor: grey[200],
                                                        color: '#fafafa',
                                                    },
                                                })}
                                            >
                                                {item.name}
                                            </Typography>
                                        ))}
                                    </Fragment>
                                ))}
                                {key !== 0 && (
                                    <Divider
                                        key={dividerKey}
                                        orientation="vertical"
                                        sx={{
                                            position: 'absolute',
                                            top: '50%',
                                            left: '-4px',
                                            transform: 'translateY(-45%)',
                                            height: '90%',
                                        }}
                                    />
                                )}
                            </Grid>
                        );
                    })}
                </Grid>
            );

            // Render the dropdown menu that should be display as list items
        } else if (collapse && name === dropdownName && listStyle === 'list') {
            template = collapse.map((item) => {
                const linkComponent = {
                    component: Link,
                    href: item.href,
                    target: '_blank',
                    rel: 'noreferrer',
                };

                const routeComponent = {
                    component: RouterLink,
                    to: item.route,
                };

                return (
                    <Typography
                        key={item.name}
                        {...(item.route ? routeComponent : linkComponent)}
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        variant="button"
                        textTransform="initial"
                        minWidth={item.description ? '14rem' : '10rem'}
                        // color={item.description ? 'dark' : 'text'}
                        fontWeight={item.description ? 'bold' : 'regular'}
                        py={item.description ? 1 : 0.625}
                        px={2}
                        sx={({ palette: { grey } }) => ({
                            borderRadius: 'md',
                            cursor: 'pointer',
                            transition: 'all 300ms linear',
                            textDecoration: 'none',
                            '&:hover': {
                                backgroundColor: grey[200],
                                fontWeight: 'bold',
                                // color: '#fafafa',

                                // '& *': {
                                //   color: '#fafafa',
                                // },
                            },
                        })}
                        onMouseEnter={({ currentTarget }) => {
                            if (item.dropdown) {
                                setNestedDropdown(currentTarget);
                                setNestedDropdownEl(currentTarget);
                                setNestedDropdownName(item.name);
                            }
                        }}
                        onMouseLeave={() => {
                            if (item.dropdown) {
                                setNestedDropdown(null);
                            }
                        }}
                    >
                        {item.description ? (
                            <Box display="flex" alignItems="center">
                                <img src={item.icon} alt="logo" width="32px" />
                                <Box ml={2} sx={{ color: '#101828' }}>
                                    {item.name}
                                    <Typography
                                        display="block"
                                        variant="button"
                                        fontWeight="regular"
                                        sx={{ transition: 'all 300ms linear', color: '#667085', textTransform: 'inherit' }}
                                    >
                                        {item.description}
                                    </Typography>
                                </Box>
                            </Box>
                        ) : (
                            item.name
                        )}
                        {/* {item.collapse && <Iconify icon="bx:chevron-down" />} */}
                    </Typography>
                );
            });
        } else if (collapse && name === dropdownName && listStyle === 'grid') {
            template = (
                <Grid key={name} container spacing={2} py={1} px={1.5} mt={1}>
                    <Grid item xs={12} sm={9} md={9} lg={9}>
                        <Grid container direction="direction">
                            {collapse.map((item) => {
                                const linkComponent = {
                                    component: Link,
                                    href: item.href,
                                    target: '_blank',
                                    rel: 'noreferrer',
                                };

                                const routeComponent = {
                                    component: RouterLink,
                                    to: item.route,
                                };

                                return (
                                    <Grid item xs={6} sm={6} md={6} lg={6}>
                                        <Typography
                                            key={item.name}
                                            {...(item.route ? routeComponent : linkComponent)}
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            variant="button"
                                            textTransform="initial"
                                            minWidth={item.description ? '14rem' : '10rem'}
                                            // color={item.description ? 'dark' : 'text'}
                                            fontWeight={item.description ? 'bold' : 'regular'}
                                            py={item.description ? 1 : 0.625}
                                            px={2}
                                            sx={({ palette: { grey, dark } }) => ({
                                                borderRadius: 'md',
                                                cursor: 'pointer',
                                                transition: 'all 300ms linear',
                                                textDecoration: 'none',
                                                '&:hover': {
                                                    backgroundColor: grey[200],
                                                    fontWeight: 'bold',
                                                    // color: '#fafafa',

                                                    // '& *': {
                                                    //   color: '#fafafa',
                                                    // },
                                                },
                                            })}
                                            onMouseEnter={({ currentTarget }) => {
                                                if (item.dropdown) {
                                                    setNestedDropdown(currentTarget);
                                                    setNestedDropdownEl(currentTarget);
                                                    setNestedDropdownName(item.name);
                                                }
                                            }}
                                            onMouseLeave={() => {
                                                if (item.dropdown) {
                                                    setNestedDropdown(null);
                                                }
                                            }}
                                        >
                                            {item.description ? (
                                                <Box display="flex" alignItems="center">
                                                    <img src={item.icon} alt="logo" width="32%" style={{ borderRadius: '6px' }} />
                                                    <Box ml={2} sx={{ color: '#101828' }}>
                                                        {item.name}
                                                        <Typography
                                                            display="block"
                                                            variant="button"
                                                            fontWeight="regular"
                                                            sx={{ transition: 'all 300ms linear', color: '#667085', textTransform: 'inherit' }}
                                                        >
                                                            {item.description}
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            ) : (
                                                item.name
                                            )}
                                        </Typography>
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={3} md={3} lg={3} sx={{ background: '#F4FBF8' }}>
                        <Typography
                            // {...(item.route ? routeComponent : linkComponent)}
                            // component={RouterLink}
                            // to={isLogin && userRole === 'USER_DTC' ? '/auth/subscribe' : '/explore-course'}
                            // display="flex"
                            // justifyContent="space-between"
                            // alignItems="center"

                            component={Link}
                            href="https://www.keyskillset.com/courses"
                            target="_blank"
                            rel="noreferrer"
                            variant="button"
                            px={2}
                            sx={({ palette: { grey, dark } }) => ({
                                borderRadius: 'md',
                                cursor: 'pointer',
                                transition: 'all 300ms linear',
                                textTransform: 'inherit',
                                textDecoration: 'none',
                                '&:hover': {
                                    backgroundColor: grey[200],
                                    fontWeight: 'bold',
                                },
                            })}
                            // onMouseEnter={({ currentTarget }) => {
                            //   if (item.dropdown) {
                            //     setNestedDropdown(currentTarget);
                            //     setNestedDropdownEl(currentTarget);
                            //     setNestedDropdownName(item.name);
                            //   }
                            // }}
                            onMouseLeave={() => {
                                // if (item.dropdown) {
                                setNestedDropdown(null);
                                // }
                            }}
                        >
                            {/* <img src={courseCreation} alt="course" width={'60%'} style={{ marginTop: '-1rem' }} /> */}
                            <Box sx={{ color: '#101828', textTransform: 'inherit' }}>
                                Explore More...
                                <Typography
                                    display="block"
                                    variant="button"
                                    fontWeight="regular"
                                    sx={{
                                        transition: 'all 300ms linear',
                                        color: '#667085',
                                        maxWidth: '95%',
                                        textTransform: 'inherit !important',
                                    }}
                                >
                                    Our courses are designed to build memory retention for a superior learning experience and knowledge
                                    building. Be 3X faster & efficient.
                                </Typography>
                            </Box>
                        </Typography>
                    </Grid>
                </Grid>
            );
        }

        return template;
    });

    // Routes dropdown menu
    const dropdownMenu = (
        <Popper
            anchorEl={dropdown}
            popperRef={null}
            open={Boolean(dropdown)}
            //   open={test}

            placement="top-start"
            transition
            style={{ zIndex: 1111 }}
            modifiers={[
                {
                    name: 'arrow',
                    enabled: true,
                    options: {
                        element: arrowRef,
                    },
                },
            ]}
            onMouseEnter={() => setDropdown(dropdownEl)}
            onMouseLeave={() => {
                if (!nestedDropdown) {
                    setDropdown(null);
                    setDropdownName('');
                }
            }}
        >
            {({ TransitionProps }) => (
                <Grow
                    {...TransitionProps}
                    sx={{
                        transformOrigin: 'left top',
                        background: '#fff',
                        boxShadow: '0px 2px 15px -10px #6a6767',
                    }}
                >
                    <Box borderRadius="lg">
                        <Typography variant="body2">
                            {/* <Iconify ref={setArrowRef} sx={{ mt: -6 }} icon="bx:chevron-down" /> */}
                        </Typography>
                        <Box shadow="lg" borderRadius="lg" p={2} mt={0.6}>
                            {renderRoutes}
                        </Box>
                    </Box>
                </Grow>
            )}
        </Popper>
    );
    const [searchText, setSearchText] = useState('');
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [search, setSearch] = useState(0);
    const [isActiveToggle, setIsActiveToggle] = useState(false);
    const allcourseDetails = useSelector((state) => state);
    const [selected, setSelected] = useState('Dashboard');

    useEffect(() => {
        setSelected(allcourseDetails?.comingfrom)
    }, [allcourseDetails.comingfrom])

    useEffect(() => {
        if (currentPath?.includes('course-details') || currentPath?.includes('course-simulation')) {
            setSelected('Courses')
        }
        else if (currentPath?.includes('SatOverview') || currentPath?.includes('sat-test-report') || currentPath?.includes('ChapterOverView') || currentPath?.includes('ChapterLevelSimulation') || currentPath?.includes('sat-chapter-test-report') || currentPath?.includes('NeetSimulation') || currentPath?.includes('NEETAssessmentDetails')) {
            setSelected('Assessments')
        }
        else if (currentPath?.includes('account')) {
            setSelected('')
        }
        else {
            setSelected(allcourseDetails?.comingfrom)
        }



    }, [allcourseDetails.comingfrom, currentPath])


    const getCourserList = async (page, searchText, rowsPerPage) => {
        const result = await adminServices.getCourseLists(page + 1, searchText, rowsPerPage);
        if (result.ok) {
            setSearchText(result.data[0])
            console.log("response of getCourse List", result)

        }
    };
    const handleClick = () => {
        localStorage.setItem('from', 'MyLearning');
        dispatch(ComingFrom("MyLearning"))
        dispatch(FromGeneralAssessmentView(false))
    };

    const handleClickCourse = (data) => {
        // Only refresh course completion when clicking Dashboard
        if (data === 'Dashboard') {
            dispatch(getCourseCompletion(allDetails?.userInfo?.id));
            dispatch(getAllcourseDetails('en'));
            dispatch(getRecomdedCourseList(allDetails?.userInfo?.id, 'en'))


        }
        dispatch(ComingFrom(data));
        dispatch(FromGeneralAssessmentView(false));
        localStorage.setItem("from", data);
    };

    const handleClickView = (data) => {
        setSelected(data);
        dispatch(ComingFrom(data))
    };



    const HearderItems = ["Dashboard", "Assessments", "Courses"];

    const ClickFunctiontoggle = () => {
        const navMenuList = document.getElementById('navMenuList');
        if (window.innerWidth <= 600) {
            navMenuList.classList.toggle('show');
        }
        setIsActiveToggle(prevState => !prevState);
    };



    return (


        <>
            <ThemeProvider>
                <MainRootStyle>
                    <RootStyle>
                        <AppBar position="static" color="inherit" elevation={0}>
                            <ToolbarStyleNew>
                                {/* Mobile-First Responsive Container */}
                                <div className="w-full flex items-center justify-between px-2 sm:px-4">
                                    {/* Logo - Always visible */}
                                    {/* <button
                                        className="flex-shrink-0 bg-transparent border-0 p-0"
                                        disabled={allDetails?.FromGeneralAssessment === true}
                                        onClick={handleNavigatetoDashboard}
                                        aria-label="Navigate to dashboard">
                                        <img
                                            id='logoKSS'
                                            src={Logo}
                                            alt="Logo"
                                            className="h-10 sm:h-12 w-auto object-contain min-w-[100px] sm:min-w-[140px]"
                                        />
                                    </button> */}
                                    <div className="flex-shrink-0" style={{ width: 236, minWidth: 236 }}>
                                        <button
                                            className="bg-transparent border-0 p-0"
                                            disabled={allDetails?.FromGeneralAssessment === true}
                                            onClick={handleNavigatetoDashboard}
                                            aria-label="Navigate to dashboard">
                                            <img
                                                id='logoKSS'
                                                src={Logo}
                                                alt="Logo"
                                                className="h-10 sm:h-12 w-auto object-contain"
                                            />
                                        </button>
                                    </div>

                                    {/* Center Section - Navigation/Search */}
                                    <div className="flex-1 flex justify-center items-center mx-2 sm:mx-4 min-w-0">
                                        {(allDetails?.comingfrom === "General Assessment" ||
                                            allDetails?.comingfrom === "NEET Assessment") ? (
                                            // Search Field for Assessments
                                            <TextField
                                                className="w-full max-w-[200px] sm:max-w-[300px] md:max-w-[450px]"
                                                variant="outlined"
                                                size="small"
                                                placeholder={t("Search for Assessment")}
                                                value={searchQuery}
                                                disabled={status}
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <Search className="text-gray-500" />
                                                        </InputAdornment>
                                                    ),
                                                    endAdornment: (
                                                        searchQuery && (
                                                            <InputAdornment position="end">
                                                                <IconButton onClick={() => { clearSearch(); }} size="small">
                                                                    <CancelIcon fontSize="small" />
                                                                </IconButton>
                                                            </InputAdornment>
                                                        )
                                                    ),
                                                }}
                                            />
                                        ) : (
                                            // Desktop Navigation - Hidden on Mobile
                                            allDetails?.FromGeneralAssessment === false && (
                                                <nav className="hidden md:flex items-center justify-center gap-1 lg:gap-2 max-w-[700px] w-full overflow-x-auto scrollbar-hide">
                                                    {/* {HearderItems.map((item) => (
                                                        <Typography
                                                            key={item}
                                                            component={RouterLink}
                                                            onClick={() => handleClickCourse(item)}
                                                            to="/auth/subscribe"
                                                            className="px-2 pb-1 text-sm lg:text-base cursor-pointer font-medium transition whitespace-nowrap flex-shrink-0"
                                                            sx={{
                                                                borderBottom: selected === item ? "2px solid #1976D2" : "2px solid transparent",
                                                                fontWeight: selected === item ? "bold" : "500",
                                                                color: selected === item ? "#1976D2" : "black",
                                                                textDecoration: "none",
                                                            }}
                                                        >
                                                            {item}
                                                        </Typography>
                                                    ))} */}
                                                </nav>
                                            )
                                        )}
                                    </div>

                                    {/* Account Popover - Always visible when logged in */}
                                    <div className="flex-shrink-0 flex items-center">
                                        {isLogin && (pathname.includes('/auth/subscribe') || allDetails?.FromGeneralAssessment === false )  && (
                                            <AccountPopover
                                                coming={'B2C'}
                                                CallBack={CallBack}
                                                navigationItems={HearderItems}
                                                selectedItem={selected}
                                                onNavigationClick={handleClickCourse}
                                            />
                                        )}
                                    </div>
                                </div>
                            </ToolbarStyleNew>
                            {dropdownMenu}
                        </AppBar>

                    </RootStyle>

                    <VideoModal
                        openModel={openContent}
                        closeModel={() => setOpenContent(!openContent)}
                        title={'How our platform works'}
                    >
                        <iframe
                            width="100%"
                            className={classes.iframeAlign}
                            src="https://www.youtube.com/embed/_Tnm3ojIADo"
                            title="KeySkillset Platform End User Experience | Excel and Financial Modeling Demo"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        />


                    </VideoModal>

                    <MainStyle>
                        <Outlet />
                        <BacKToTop />
                    </MainStyle>
                </MainRootStyle>
            </ThemeProvider>
        </>

    );
}

const useStyles = makeStyles((theme) => ({
    iframeAlign: {
        height: '515px',
        width: '100%',
        '@media (max-width: 768px)': {
            height: '350px !important',
        },
        '@media (max-width: 600px)': {
            height: '230px !important',
        },
    },
    linkText: {
        color: '#000',
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    linkTextActive: {
        color: palette.primary.main,
        fontSize: '1.2rem',
    },
    logo: {
        // '&:hover': {},
    },
    menuItem: {
        padding: '0px 12px',
        color: '#667085',
        fontSize: '1rem',
    },
    button: {
        borderRadius: '28px',
    },
    container: {
        maxWidth: '1440px',
        '@media (min-width: 601px)': {
            padding: '0px 2rem',
        },

        '@media (min-width: 1201px)': {
            padding: ' 0px 112px',
            paddingRight: '35px',
            zIndex: '999'
        },
        '@media (max-width: 600px)': {
            padding: '0px 1rem',
        },
    },
    watchDemo: {
        textDecoration: 'none',
        fontSize: '1rem',
        cursor: 'pointer',
        '@media (max-width: 362px)': {
            lineHeight: 1,
            marginTop: '8px',
        },
    },

    videoIcon: {
        color: '#FE7000',
        '@media (max-width: 362px)': {
            marginTop: '12px',
        },
    },
    menuIcon: {
        display: 'none',
        fontSize: '32px',
        color: '#282828',
        marginLeft: '10px',
        '@media (max-width: 600px)': {
            display: 'block'
        }
    },
    closeIcon: {
        display: 'none',
        fontSize: '32px',
        color: '#282828',
        marginLeft: '10px',
    },
    navMenu: {
        '@media (max-width: 600px)': {
            display: 'flex',
            background: '#fff',
            flexDirection: 'column',
            position: 'absolute',
            right: '0',
            top: '72px',
            borderRadius: '8px',
            boxShadow: '0px 5px 5px -3px rgba(145, 158, 171, 0.2), 0px 8px 10px 1px rgba(145, 158, 171, 0.14), 0px 3px 14px 2px rgba(145, 158, 171, 0.12)',
            transition: 'opacity 330ms cubic-bezier(0.4, 0, 0.2, 1), transform 220ms cubic-bezier(0.4, 0, 0.2, 1)'
        },
    },
    navMenufield: {
        '@media (max-width: 600px)': {
            paddingTop: '3px',
            paddingBottom: '6px',
            cursor: 'pointer',
            marginTop: '5px',
            marginBottom: '0px',
            fontSize: '17px'
        },
    }
}));